export default __webpack_public_path__ + "msc-thesis-ggonzalez.pdf";